import "./LogoutWarning.css";

export default function LogoutWarning({ onClose, onLogout }) {
  return (
    <div
      className="logout-warning-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="logout-warning-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="logout-warning-title"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="logout-warning-dialog__eyebrow">Almost ready</p>
        <h2 id="logout-warning-title" className="logout-warning-dialog__title">
          Leave for now?
        </h2>
        <p className="logout-warning-dialog__copy">
          Your profile isn&apos;t finished yet. If you leave, we&apos;ll sign
          you out. You can pick this up anytime you come back.
        </p>
        <div className="logout-warning-dialog__actions">
          <button
            type="button"
            className="logout-warning-btn logout-warning-btn--ghost"
            onClick={onClose}
          >
            Keep going
          </button>
          <button
            type="button"
            className="logout-warning-btn logout-warning-btn--leave"
            onClick={onLogout}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
